import { render, staticRenderFns } from "./ModalResultadoDiagnostico.vue?vue&type=template&id=33f49142&lang=pug"
import script from "./ModalResultadoDiagnostico.vue?vue&type=script&lang=js"
export * from "./ModalResultadoDiagnostico.vue?vue&type=script&lang=js"
import style0 from "./ModalResultadoDiagnostico.vue?vue&type=style&index=0&id=33f49142&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports